import { render, staticRenderFns } from "./layer.vue?vue&type=template&id=64b9f97c&scoped=true&"
import script from "./layer.vue?vue&type=script&lang=js&"
export * from "./layer.vue?vue&type=script&lang=js&"
import style0 from "./layer.vue?vue&type=style&index=0&id=64b9f97c&lang=scss&scoped=true&"
import style1 from "./layer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b9f97c",
  null
  
)

export default component.exports